import { toast } from "sonner";

export const copyToClipboard = (text: string, toastMessage: string) => {
  navigator.clipboard.writeText(text).then(() =>
    toast(toastMessage, {
      duration: 1500,
    })
  );
};
